module.exports = __webpack_public_path__ + "img/poster_support24.991b0db1.jpg";